var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{ref:"editor",staticClass:"editor mb-4",attrs:{"value":_vm.value,"onInput":_vm.onInput,"editorId":_vm.editorId,"uid":_vm.uid,"wid":_vm.WID}})
}
var staticRenderFns = []

export { render, staticRenderFns }